<mat-toolbar class="toolbar">
    <form class="search-form" [formGroup]="searchFormGroup">
      <button mat-icon-button (click)="showConfigurationCreationForm()" matTooltip="Create new configuration">
        <mat-icon>add</mat-icon>
      </button>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Configuration key</mat-label>
        <input matInput type="text" placeholder="HeartbeatInterval" formControlName="key">
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Vendor</mat-label>
        <input matInput type="text" placeholder="OCPP" formControlName="vendor">
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Model</mat-label>
        <input matInput type="text" placeholder="OCPP" formControlName="model">
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Version</mat-label>
        <input matInput type="text" placeholder="1.6" formControlName="version">
      </mat-form-field>
    <div class="spacer"></div>
    <button mat-raised-button color="primary" (click)="search('profile')">
      <mat-icon>ev_station</mat-icon>
      Search profile
    </button>
    <button mat-raised-button color="primary" (click)="search('all')">
      <mat-icon>search</mat-icon>
      Search all
    </button>
  </form>
</mat-toolbar>

<form class="create-form" [formGroup]="createFormGroup" *ngIf="configurationCreationFormVisible">
  <button mat-icon-button color="primary" (click)="configurationCreationFormVisible = false" matTooltip="Close creation form">
    <mat-icon>close</mat-icon>
  </button>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Key</mat-label>
    <input matInput type="text" placeholder="HeartbeatInterval" formControlName="key">
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Value</mat-label>
    <input matInput type="text" placeholder="60" formControlName="value">
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Vendor</mat-label>
    <input matInput type="text" placeholder="OCPP" formControlName="vendor">
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Model</mat-label>
    <input matInput type="text" placeholder="OCPP" formControlName="model">
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Version</mat-label>
    <input matInput type="text" placeholder="1.6" formControlName="version">
  </mat-form-field>
  <div class="spacer"></div>
  <button mat-raised-button color="primary" (click)="create()">
    <mat-icon>add</mat-icon>
    Create
  </button>
</form>


<ng-container *ngIf="ocppExpectedConfigurations.length > 0; else empty">
  <div class="configuration-list">
    <ng-container *ngFor="let config of ocppExpectedConfigurations; let index = index">
      <mat-divider *ngIf="index"></mat-divider>
      <div class="configuration-item">
        <mat-icon>settings</mat-icon>
        <span class="configuration-key">{{config.key}}</span>
        <div class="filters">
        <mat-chip-set>
          <mat-chip *ngIf="config.vendor">{{config.vendor}}</mat-chip>
          <mat-chip *ngIf="config.model">{{config.model}}</mat-chip>
          <mat-chip *ngIf="config.version">{{config.version}}</mat-chip>
        </mat-chip-set>

        </div>
        <mat-form-field subscriptSizing="dynamic" class="configuration-value">
          <input matInput type="text" [(ngModel)]="config.value" readonly>
        </mat-form-field>
        <button mat-icon-button (click)="editConfiguration(config)" matTooltip="Submit new value">
          <mat-icon>send</mat-icon>
        </button>
        <button mat-icon-button (click)="deleteConfiguration(config)" matTooltip="Delete configuration">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #empty>
  <div class="disclaimer">
    <mat-icon>sentiment_dissatisfied</mat-icon>
    <p>No configurations found</p>
  </div>
</ng-template>
